import { ThreadsQueryThread } from "@/app/Threads/GraphQL/threadQueries";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { ThreadUserAvatar } from "@/app/Threads/Components/ThreadUserAvatar";
import { matchesAnyToken } from "@/app/Threads/utils/searchHighlight";
import { cn } from "@/lib/utils";
import { useThreadPresence } from "@/app/Threads/Components/ThreadPresenceProvider";
import { useTranslations } from "use-intl";

const MATCH_CLASSES =
  "relative z-10 outline-yellow-300 shadow-[0_0_0_1.5px_#fde68a,0_0_7px_2px_rgb(250_204_21_/_0.8)]";
const DEFAULT_CLASSES = "outline-black/5 ring-2 ring-white";

export function ThreadMembers({
  thread,
  size = 8,
  searchTokens = [],
}: {
  thread: ThreadsQueryThread;
  size?: number;
  searchTokens?: string[];
}) {
  const t = useTranslations("thread.presence");
  const presence = useThreadPresence();

  return (
    <div className="isolate flex -space-x-1">
      {thread.subscribers.map((s) => {
        const name = s.user.name ?? "";
        const isMatch = matchesAnyToken(name, searchTokens);
        const stateClasses = isMatch ? MATCH_CLASSES : DEFAULT_CLASSES;
        const isPresent = presence?.presentUserIds.has(s.user.id) ?? false;
        return (
          <Tooltip key={s.id}>
            <TooltipTrigger className="relative">
              <ThreadUserAvatar
                className={cn(`size-${size}`, stateClasses)}
                name={s.user.name}
                media={s.user.profilePicture}
              />
              {isPresent ? (
                <span className="absolute bottom-0 right-0 z-20 size-2 rounded-full bg-green-500 ring-2 ring-white" />
              ) : null}
            </TooltipTrigger>
            <TooltipContent>
              {isPresent ? `${name} · ${t("viewing")}` : name}
            </TooltipContent>
          </Tooltip>
        );
      })}
    </div>
  );
}
